import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useGamesNavigation } from "@state/hooks/games/useGamesNavigation";
import { useRegulationAgency } from "@state/hooks/info";
import InfoMessageComponent from "@components-shared/InfoMessageComponent";
import Markdown from "@components-shared/Markdown";
import { useFixBody } from "@state/hooks/shared";

export default observer(function HeaderResponsibleGamingConfirmation(props: {
	setFlag: (value: boolean) => void;
}) {
	const { t } = useTranslation();
	const regulationDefinitionsStore = useRegulationAgency();

	const { notifyLugasForRedirection, handleGamesRedirection } =
		useGamesNavigation();

	useFixBody(true, true);

	return (
		<div className="popup popup--mega">
			<div className="popup__card popup--mega__card">
				<div className="popup__header">
					<div className="popup__title">
						{t("RESPONSIBLE_GAMING_CONFIRMATION.TITLE")}
					</div>
				</div>

				<div
					id="responsible-gaming"
					className="popup__body markdown markdown--responsible-popup"
				>
					<InfoMessageComponent
						type="warning"
						message={t("RESPONSIBLE_GAMING_CONFIRMATION.TEXT")}
						addClassName="u-mar--bottom--xsml"
						textClass="message__text"
					/>

					{regulationDefinitionsStore?.responsibleGamingWeb
						?.content && (
						<Markdown
							content={
								regulationDefinitionsStore.responsibleGamingWeb
									.content
							}
						></Markdown>
					)}
				</div>

				<div className="popup__footer">
					<button
						type="button"
						className="popup__btn btn btn--base btn--primary--inverted"
						onClick={() => props.setFlag(false)}
					>
						{t("COMMON.CANCEL")}
					</button>

					<button
						type="button"
						className="popup__btn btn btn--base btn--primary"
						onClick={async () => {
							notifyLugasForRedirection();
							props.setFlag(false);
							await handleGamesRedirection();
						}}
					>
						{t("COMMON.CONFIRM")}
					</button>
				</div>
			</div>
		</div>
	);
});
